import { type FC, type PropsWithChildren, useEffect } from 'react';
import { useCreation } from '@/hooks';
import { QueryClientProvider } from 'react-query';
import { useActiveUser, useCustomerId } from '../App';
import { createQueryClient, setGlobalQueryClient } from './client';

export const AppQueryClient: FC<PropsWithChildren> = ({ children }) => {
  const user = useActiveUser();
  const customerId = useCustomerId();

  const queryClient = useCreation(createQueryClient, [user?._id, customerId]);

  // temporary until global query client variable is replaced
  useEffect(() => {
    setGlobalQueryClient(queryClient);
  }, [queryClient]);

  return (
    // WARN: key is really important here otherwise some child queries (e.g favouries) are unmounted
    // and not mounted again.
    // TODO: I was unable to find if it's a bug of react-query v3 or desired behavior so try to
    // remove it when updating react-query to next major version.
    // (https://enmontech.atlassian.net/browse/ENMON-2937)
    <QueryClientProvider key={`${user?._id ?? ''}${customerId ?? ''}`} client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};
